import type { StateAction } from "@entrilia/shared/types";
import type { DescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import type { MessagePublishStatus } from "../../../../api/types/documentCollectionTypes";
import type { SearchInvestorDocumentsRequest } from "../../../../api/types/fundStructureTypes";

export interface FundStructureDocumentsFilterState {
  searchTerm: string;
  statuses: MessagePublishStatus[];
  categoryIds: string[];
  fundIds: string[];
  fundInvestorIds: string[];
  dateRange?: DescriptiveDateRange;
}

export const getInitialFundStructureDocumentsFilterState = (): FundStructureDocumentsFilterState => ({
  searchTerm: "",
  statuses: [],
  categoryIds: [],
  fundIds: [],
  fundInvestorIds: [],
  dateRange: undefined,
});

export const hasActiveFilters = (state: FundStructureDocumentsFilterState): boolean =>
  state.statuses.length > 0 ||
  state.categoryIds.length > 0 ||
  state.fundIds.length > 0 ||
  state.fundInvestorIds.length > 0 ||
  state.dateRange !== undefined;

export const getSearchDocumentsFilterPayload = (
  filterState: FundStructureDocumentsFilterState
): Omit<SearchInvestorDocumentsRequest, "range"> => ({
  search: filterState.searchTerm.trim().toLowerCase(),
  fundIds: filterState.fundIds.length === 0 ? undefined : filterState.fundIds,
  fundInvestorIds: filterState.fundInvestorIds.length === 0 ? undefined : filterState.fundInvestorIds,
  categoryIds: filterState.categoryIds.length === 0 ? undefined : filterState.categoryIds,
  publishingStatusFilter:
    filterState.statuses.length === 1 && filterState.statuses[0] === "Live"
      ? "Live"
      : filterState.statuses.length === 1 && filterState.statuses[0] === "Preview"
        ? "Preview"
        : "Any",
  sentAtFrom: filterState.dateRange?.from?.toISOString(),
  sentAtTo: filterState.dateRange?.to?.toISOString(),
});

// State actions
export const clearFiltersAction = (): StateAction<FundStructureDocumentsFilterState> => (state) => ({
  ...getInitialFundStructureDocumentsFilterState(),
  searchTerm: state.searchTerm,
});
